/**
 * Iterable sequence excluding strings.
 *
 * Any Iterable except string (since strings are iterable but usually need special handling).
 *
 * @example
 * ```ts
 * const arr: Sequence<number> = [1, 2, 3]
 * const gen: Sequence<number> = function*() { yield 1 }()
 * ```
 */
export type Sequence<T> = Exclude<Iterable<T>, string>
